import { render } from "./loading.vue?vue&type=template&id=70f73602&scoped=true"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=70f73602&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\hujing\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70f73602"]])

export default __exports__